export const typography = {
  fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
  sizes: {
    xs: 11,
    sm: 13,
    md: 14,
    lg: 16,
    xl: 20,
    xxl: 26
  },
  weight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }
};
